import React, { useEffect, useState } from 'react';

import { FormElementChangeEvent, NumberInput, NumberInputProps, OnBlurCallback, OnChangeCallback } from './index';

import Input, { InputProps } from './input';

import { GradeType } from '../../types/form';

export type GradeElementProps = {
  name?: string;
  valueType?: GradeType;
  onBlur?: OnBlurCallback;
  onChange?: OnChangeCallback;
  value: string | undefined;
  decimalPlaces?: number;
};
export type GradeLetterProps = Omit<InputProps, 'onBlur' | 'onChange' | 'value' | 'valueType'> & GradeElementProps;
export type GradeNumberProps = Omit<NumberInputProps, 'onBlur' | 'onChange' | 'value' | 'valueType'> &
  GradeElementProps;
// TODO: Figure out how to set conditional types based on the types
export type GradeProps<T> = T extends NumberInputProps | undefined ? GradeLetterProps : GradeNumberProps;

const Grade = React.memo(function Grade({
  valueType,
  name,
  onChange,
  value,
  decimalPlaces,
  ...props
}: GradeProps<GradeLetterProps>) {
  const [currentValue, setCurrentValue] = useState(value);
  useEffect(() => {
    if (value !== currentValue) {
      setCurrentValue(value);
    }
  }, [value, currentValue]);

  const regex = /^([A-F]{1}[+|-]{0,1})/g;
  const handleChangeForLetters =
    onChange &&
    (({ name, value }: FormElementChangeEvent) => {
      if (value === null || value === undefined || value === '' || value.match(regex) === null) {
        onChange({ name, value: undefined });
      } else {
        onChange({ name, value: value.match(regex)[0] });
      }
    });
  return valueType === GradeType.Number ? (
    <NumberInput
      {...props}
      name={name}
      onChange={onChange}
      precision={decimalPlaces != undefined ? decimalPlaces : 2}
      value={value ? Number(value) : undefined}
    />
  ) : (
    <Input {...props} name={name} onChange={handleChangeForLetters} maxLength={2} value={currentValue} />
  );
});

export default Grade;
